import { VERTICAL_PATHS } from "./consts";
const fetchCreator = (type, instance, locale, options) => {
  let url = `/_serverless/vertical-oembed/query-${VERTICAL_PATHS[type]}?language=${locale}`;
  if (options?.limit) {
    url += `&limit=${options.limit}`;
  }
  if (options?.filter) {
    url += `&filter=${options.filter}`;
  }
  return typeof fetch === "function" ? fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: instance
    }
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw res.statusText;
    }
  }) : Promise.resolve(false);
};
const getItems = (type, instance, locale, options) => {
  return fetchCreator(type, instance, locale, options).then((response) => {
    if (response.status) {
      return response.status === "success" ? response.data : [];
    }
    return response;
  });
};
class AbstractVerticalSearchModule {
}
class VerticalSearchModule extends AbstractVerticalSearchModule {
  constructor(verticalType, instance, locale, limit) {
    super();
    this.verticalType = verticalType;
    this.instance = instance;
    this.locale = locale;
    this.limit = limit;
  }
  isInstalled() {
    if (!this.isVerticalInstalled) {
      this.isVerticalInstalled = fetchCreator(this.verticalType, this.instance, this.locale, {
        limit: 0
      }).then((res) => !res.errMsg);
    }
    return this.isVerticalInstalled;
  }
  search(searchInput) {
    if (this.verticalType === "product" || this.verticalType === "event") {
      return getItems(this.verticalType, this.instance, this.locale, {
        limit: this.limit,
        filter: searchInput
      });
    }
    if (!this.items) {
      this.items = getItems(this.verticalType, this.instance, this.locale, { limit: this.limit });
    }
    return this.items.then(
      (res) => res.filter((item) => item.name.toLowerCase().includes(searchInput.toLowerCase()))
    );
  }
}
export {
  VerticalSearchModule as default
};
//# sourceMappingURL=VerticalSearchModule.js.map
